/**
 * Tiny client-side CSV builder + download helper.
 *
 * Used by analytics tables that paginate on screen but export the full,
 * unpaginated dataset. Pure string building; no network calls.
 */

function csvCell(value: string | number | null | undefined): string {
  if (value == null) return '';
  const s = String(value);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCSV(headers: string[], rows: (string | number | null | undefined)[][]): string {
  const lines = [headers.map(csvCell).join(',')];
  for (const row of rows) {
    lines.push(row.map(csvCell).join(','));
  }
  return lines.join('\n');
}

export function downloadTextFile(filename: string, mime: string, text: string): void {
  const blob = new Blob([text], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

/** Build a CSV from headers + rows and trigger a timestamped download. */
export function downloadCSV(
  baseName: string,
  headers: string[],
  rows: (string | number | null | undefined)[][],
): void {
  const stamp = new Date().toISOString().slice(0, 10);
  downloadTextFile(`${baseName}_${stamp}.csv`, 'text/csv;charset=utf-8', toCSV(headers, rows));
}
